import { useMemo, useCallback } from 'react';
import { FilterField } from '../types';

type UseResetFiltersProps = {
  filters: Record<string, any>;
  fields: FilterField[];
  onChange: (updatedFilters: Record<string, any>) => void;
};

export const useResetFilters = ({ filters, fields = [], onChange }: UseResetFiltersProps) => {
  const fieldsNames = useMemo(
    () =>
      fields
        .filter((field) => !(field.required ?? false))
        .filter((field) => (field.type === 'autocomplete' ? !field.disableClearable : true))
        .map((field) => field.name),
    [fields]
  );

  const handleReset = useCallback(() => {
    const newFilters = { ...filters };

    fieldsNames.forEach((fieldName) => {
      if (Array.isArray(newFilters[fieldName])) {
        newFilters[fieldName] = [];
      } else {
        delete newFilters[fieldName];
      }

      if (`${fieldName}From` in newFilters) {
        delete newFilters[`${fieldName}From`];
      }

      if (`${fieldName}Until` in newFilters) {
        delete newFilters[`${fieldName}Until`];
      }
    });

    onChange(newFilters);
  }, [filters, fieldsNames, onChange]);

  return handleReset;
};
